import { Fade } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { getFile } from '../../api/bot';

const PhotoItem = ({ photo, alt }) => {
  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <Fade in={!!photo}>
        <img
          {...{ src: getFile({ photo }), alt }}
          style={{ width: 'inherit', height: 'auto' }}
        />
      </Fade>
    </Box>
  );
};

export default PhotoItem;
